<template>
  <div id="theme-switcher" v-if="isVisible">
    <div class="btn-group btn-group-xs">
      <i
        v-if="isThemeVisible(theme.DARK)"
        title="Design: Dunkel"
        class="fa fa-moon-o btn btn-xs btn-dark"
        @click="toggleTheme(theme.DARK)"
        :class="theme.DARK === currentTheme ? 'active' : ''"
      ></i>
      <i
        v-if="isThemeVisible(theme.TEST)"
        title="Design: Testsystem"
        class="fa fa-shield btn btn-xs btn-dark"
        @click="toggleTheme(theme.TEST)"
        :class="theme.TEST === currentTheme ? 'active' : ''"
      ></i>
      <i
        v-if="isThemeVisible(theme.LIGHT)"
        title="Design: Hell"
        class="fa fa-sun-o btn btn-xs btn-dark"
        @click="toggleTheme(theme.LIGHT)"
        :class="theme.LIGHT === currentTheme ? 'active' : ''"
      ></i>
    </div>
  </div>
</template>

<script lang="ts">
import { Stage } from '../enums/app-config';

enum Theme {
  DARK = 'theme-dark',
  LIGHT = 'theme-light',
  TEST = 'theme-test',
}

const localStorageKey = 'sw-theme';
const stageMapping = {
  [Stage.DEV]: {
    [Theme.DARK]: true,
    [Theme.LIGHT]: true,
    [Theme.TEST]: true,
  },
  [Stage.TEST]: {
    [Theme.DARK]: true,
    [Theme.TEST]: true,
  },
  [Stage.LIVE]: null,
};

export default {
  name: 'ThemeSwitcher',
  data() {
    return {
      theme: Theme,
      currentTheme: null,
    };
  },
  computed: {
    isVisible() {
      return !!stageMapping[appConfig.stage];
    },
  },
  methods: {
    isThemeVisible(theme: Theme) {
      return stageMapping[appConfig.stage][theme];
    },
    toggleTheme(theme: Theme) {
      if (this.currentTheme === theme) {
        return;
      }

      const htmlClassList = document.querySelector('html').classList;

      Object.values(Theme).forEach((item) => {
        htmlClassList.remove(item);
      });

      htmlClassList.add(theme);

      localStorage.setItem(localStorageKey, theme);

      this.currentTheme = theme;
    },
  },
  beforeMount(): any {
    const theme = localStorage.getItem(localStorageKey);

    if (theme) {
      this.toggleTheme(theme);
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  display: flex;
}

i {
  color: var(--text-color-light);
  cursor: pointer;
  width: 24px;

  &.active {
    color: var(--color-primary);
  }
}
</style>
